<template>
  <div class="mbox">
    <div id="map" v-if="!isMobile"></div>
    <div id="map_m" v-if="isMobile"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import { isMobile } from 'mobile-device-detect';
 
export default {
  name: 'mbox',
  data () {
    return {
      isMobile: isMobile
    }
  },
  props: {
    msg: String
  },
  mounted() {
    var center_gps = isMobile ? [127.02273, 37.50375] : [127.025056, 37.50402];
    var marker_gps = [127.02173, 37.50415];
    mapboxgl.accessToken = 'pk.eyJ1IjoiMmJkZXYiLCJhIjoiY2trZ2tmYWNtMHI2MjJ1cGU1b3hucGw3aiJ9.n0bEGzVD6HJE3Ye3KaqqXw';
    var map = new mapboxgl.Map({
      container: isMobile ? 'map_m' : 'map',
      style: 'mapbox://styles/mapbox/light-v10',
      center: center_gps,
      zoom: 16.5,
      scrollZoom:false,
      attributionControl: false
    });

    // create DOM element for the marker
    var el = document.createElement('div');
    el.id = isMobile ? 'marker_m' : 'marker';

    var marker = new mapboxgl.Marker(el)
      .setLngLat(marker_gps)
      //.setPopup(popup) // sets a popup on this marker
      .addTo(map);

    map.addControl(new mapboxgl.NavigationControl({
      showCompass: false
    }));

    //모마일이면 위치조정
    /*
    if(isMobile){
      map.flyTo({
        center: [127.02173, 37.50410],
        essential: true // this animation is considered essential with respect to prefers-reduced-motion
      });
    }*/
  }
}
</script>

<style>
#marker_m {
  background-image: url('../assets/custom/img/marker_m.png');
  background-size: cover;
  width: 25px;
  height: 38px;
  cursor: pointer;
  top:15px;
}

#marker {
  background-image: url('../assets/custom/img/marker.png');
  background-size: cover;
  width: 51px;
  height: 76px;
  cursor: pointer;
}

#map {
  width: 100%;
  height: 633px;
}
#map_m {
  width: auto;
  height: 430px;
}
.mapboxgl-popup {  
  max-height: 600px;
  font: 11px/20px 'Open Sans', sans-serif;
  border-radius: 5px;
}
.mapboxgl-popup-content {
    width: 390px;
    height: 65px;
    padding: 0px 0px 5px 15px;
    text-align: left;
    color:#fff;
    background-color: #000
}

/* 네비아이콘 추가설정, 무신사 참고 */
.mbox .mapboxgl-ctrl-top-right button {
    display: block;
    background: url(../assets/custom/img/icon_map.png) no-repeat;
}

/*
.mbox #map_m .mapboxgl-ctrl-top-right button {
    display: block;
    background: url(../assets/custom/img/icon_map_2.png) no-repeat;
}
*/

.mbox #map .mapboxgl-ctrl-top-right {
    right: 50%;
    margin-right: -640px;
    height: 120px;
}

.mbox #map_m .mapboxgl-ctrl-top-right {
    right: 50%;
    margin-right: -170px;
    height: 120px;
}

.mapboxgl-ctrl-top-right {
    top: 0;
    right: 0;
}

.mapboxgl-ctrl-top-right, .mapboxgl-ctrl-bottom-left, .mapboxgl-ctrl-bottom-right {
    position: absolute;
    pointer-events: none;
    z-index: 2;
}

.mapboxgl-ctrl-top-right .mapboxgl-ctrl {
    margin: 10px 10px 0 0;
    float: right;
}

.mbox .mapboxgl-ctrl-group {
    box-shadow: none;
    margin-top: 30px;
    background: none;
}

.mbox .mapboxgl-ctrl-group > button {
    border: 0;
    margin-bottom: 10px;
}

.mbox .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-in {
    width: 35px;
    height: 35px;
    background-position: -40px 0;
}

.mbox .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-out {
    width: 35px;
    height: 35px;
    background-position: -80px 0;
}
/*
.mbox #map .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-in {
    width: 35px;
    height: 35px;
    background-position: -40px 0;
}

.mbox #map .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-out {
    width: 35px;
    height: 35px;
    background-position: -80px 0;
}

.mbox #map_m .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-in {
    width: 70px;
    height: 70px;
    background-position: -80px 0;
}

.mbox #map_m .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-out {
    width: 70px;
    height: 70px;
    background-position: -160px 0;
}
*/

.mapboxgl-ctrl button.mapboxgl-ctrl-zoom-in .mapboxgl-ctrl-icon,
.mapboxgl-ctrl button.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon
{
    background-image: none;
}
</style>


// WEBPACK FOOTER //
// src/components/mapbox_com.vue